'use client'

type Props = {
  /** Texto pequeño superior (uppercase). */
  kicker?: string
  /** Título principal (usa la fuente display del tema → serif en editorial). */
  title: string
  /** Número decorativo opcional (ej. "01"). */
  number?: string
}

/**
 * Encabezado de sección editorial, theme-aware: número decorativo + kicker +
 * título en la fuente display del tema + línea separadora. Da a cada sección un
 * aire de "primer nivel" coherente en todos los temas (serif en editorial, sans
 * bold en vibrant/classic, vía --ms-font-display).
 */
export function SectionHeader({ kicker, title, number }: Props) {
  return (
    <div className="flex items-end gap-4 sm:gap-5">
      {number && (
        <span
          className="text-[15px] font-bold pb-1.5 hidden sm:block"
          style={{ color: 'var(--ms-accent)', fontFamily: 'var(--ms-font-display)' }}
        >
          {number}
        </span>
      )}
      <div className="flex-1 min-w-0">
        {kicker && (
          <p
            className="text-[11px] font-bold uppercase tracking-[0.22em] mb-2"
            style={{ color: 'var(--ms-text-muted)' }}
          >
            {kicker}
          </p>
        )}
        <h2
          className="font-extrabold leading-[1.02] tracking-[-0.01em] text-[30px] sm:text-[40px]"
          style={{ color: 'var(--ms-text)', fontFamily: 'var(--ms-font-display)' }}
        >
          {title}
        </h2>
      </div>
      <span className="flex-none w-16 sm:w-28 h-px mb-3.5 hidden sm:block" style={{ background: 'var(--ms-border)' }} />
    </div>
  )
}
